export default "__VITE_ASSET__rLCheRCA__"